import { render, staticRenderFns } from "./PerfilEditar.vue?vue&type=template&id=01f2634e"
import script from "./PerfilEditar.vue?vue&type=script&lang=js"
export * from "./PerfilEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports